const cardsData = [
  {
    id: 1,
    rname: 'Cake',
    imgdata:
      'https://b.zmtcdn.com/data/dish_photos/17e/6bdd9ed307e68799f90aae734976c17e.jpg?output-format=webp',
    recommendedDishes: 'Burger, Pastry',
    somedata: ' 1175 + order placed from here recently',
    price: 550,
    rating: '4.8',
    qnty: 0,
  },
  {
    id: 2,
    rname: 'Burger',
    imgdata:
      'https://b.zmtcdn.com/data/pictures/0/19692880/030efca74281a268d127adc9eec59e2c_o2_featured_v2.jpg',
    recommendedDishes: 'Cake, Pastry',
    somedata: ' 2525 + order placed from here recently',
    price: 65,
    rating: '3.9',
    qnty: 0,
  },
  {
    id: 3,
    rname: 'Momos',
    imgdata:
      'https://b.zmtcdn.com/data/pictures/chains/2/20109222/891a953172723ed919e7d0156b54470d_o2_featured_v2.jpg',
    recommendedDishes: 'Pizza, Pasta',
    somedata: ' 650 + order placed from here recently',
    price: 70,
    rating: '4.2',
    qnty: 0,
  },
  {
    id: 4,
    rname: 'Tea',
    imgdata:
      'https://b.zmtcdn.com/data/pictures/8/19531358/3f42c9a2c21dc9e0d2d1dbc6adb3decc_o2_featured_v2.jpg',
    recommendedDishes: 'Samosa',
    somedata: ' 300 + order placed from here recently',
    price: 30,
    rating: '3.8',
    qnty: 0,
  },
  {
    id: 5,
    rname: 'Pizza',
    imgdata:
      'https://b.zmtcdn.com/data/pictures/1/19759321/5dc7ba65e57c60b6ef5827e6a9acb445_o2_featured_v2.jpg    ',
    recommendedDishes: 'Pasta, Noodles',
    somedata: '1050 + order placed from here recently',
    price: 330,
    rating: '4.4',
    qnty: 0,
  },
  {
    id: 6,
    rname: 'Samosa',
    imgdata:
      'https://b.zmtcdn.com/data/dish_photos/67d/6efee56e80af7a4bd8b3708ec0fff67d.jpg?output-format=webp',
    recommendedDishes: 'Wraps, Tea',
    somedata: ' 1100 + order placed from here recently',
    price: 20,
    rating: '3.8',
    qnty: 0,
  },
  {
    id: 7,
    rname: 'Pasta',
    imgdata:
      'https://b.zmtcdn.com/data/dish_photos/855/6f6730abdfe443d480bd67a41c884855.jpg',
    recommendedDishes: 'Burger, Pizza',
    somedata: '500 + order placed from here recently',
    price: 170,
    rating: '3.8',
    qnty: 0,
  },
  {
    id: 8,
    rname: 'Veg Roll',
    imgdata:
      'https://b.zmtcdn.com/data/dish_photos/bc8/fbed1dd3fd60f5946565c4bfdd025bc8.jpg?output-format=webp',
    recommendedDishes: 'Momos',
    somedata: '500 + order placed from here recently',
    price: 40,
    rating: '3.2',
    qnty: 0,
  },
  {
    id: 9,
    rname: 'Noodles',
    imgdata:
      'https://b.zmtcdn.com/data/dish_photos/3ea/785546949ad667211bba16b39a01a3ea.jpg?output-format=webp',
    recommendedDishes: 'Burger',
    somedata: '2525 + order placed from here recently',
    price: 120,
    rating: '3.8',
    qnty: 0,
  },
];

export default cardsData;
